const fieldMap = {
  // summary fields
  totalCharge: "Subtotal",
  totalPfc: "PFC",
  totalCod: "COD",
  totalPriority: "Priority",
  serviceFee: "Service Fee",
  extra: "Adjustments",
  adjustmentDescription: "Adjustment Description",
  hstTax: "HST",
  creditMemo: "Credit Memo",
  totalNet: "Total",
  count: "Count",

  // orders fields
  code: "Order Code",
  invoiceNumber: "Invoice Number",
  pickupAppointmentDate: "Pickup Appointment Date",
  actualDeliveryDate: "Actual Delivery Date",
  distance: "Distance",
  charge: "Charge",
  chargeWithoutPfc: "Charge Without PFC",
  pfc: "PFC",
  codAmount: "COD Amount",
  priority: "Priority",
  total: "Total",
  storeName: "Store Name",
  storeAddress1: "Address Line 1",
  storeAddress2: "Address Line 2",
  storeCity: "City",
  storePostalCode: "Postal Code",
  storeState: "State",
};

function renameFields(obj, fieldMap) {
  const rename = (input) => {
    if (Array.isArray(input)) {
      return input.map(rename);
    } else if (input !== null && typeof input === "object") {
      let renamedObj = {};

      for (const [key, value] of Object.entries(input)) {
        // Skip adjustmentDescription so it's not included
        if (key === "adjustmentDescription") continue;

        // Handle the 'extra' key logic
        if (key === "extra") {
          const description = input.adjustmentDescription;

          // Use description as key if it exists and is not empty
          const dynamicKey =
            description && description.trim() !== ""
              ? description
              : fieldMap.extra || key;

          renamedObj[dynamicKey] = rename(value);
        } else {
          const newKey = fieldMap[key] || key;
          renamedObj[newKey] = rename(value);
        }
      }

      return renamedObj;
    }

    return input;
  };

  return rename(obj);
}

// Convert data to CSV format
const convertToCSV = (data) => {
  const { summary, orders } = data;

  // Prepare CSV content
  let csvContent = "";

  // Add orders section first
  csvContent += "ORDERS\n";

  if (orders && orders.length > 0) {
    const headers = Object.keys(orders[0]);
    csvContent += headers.join(",") + "\n";

    orders.forEach((order) => {
      const values = headers.map((header) => {
        const value = order[header];
        if (
          typeof value === "string" &&
          (value.includes(",") || value.includes('"'))
        ) {
          return `"${value.replace(/"/g, '""')}"`;
        }
        return value;
      });
      csvContent += values.join(",") + "\n";
    });
  }

  // Add blank lines for separation
  csvContent += "\n\n";

  // Add summary section at the bottom
  csvContent += ",,,,,,,,SUMMARY\n";
  Object.entries(summary).forEach(([key, value]) => {
    if (value) {
      csvContent += `,,,,,,,,${key},${value}\n`;
    }
  });

  return csvContent;
};

// Download CSV file
export const downloadCSV = (apiData, name) => {
  const data = renameFields(apiData, fieldMap);
  const csv = convertToCSV(data);
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");

  // Create download link
  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute(
      "download",
      `${name}.csv`
    );
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};
